import store from "../../index.js";
import api from "../../../utils/api.js";
import OrderTicketAcConstant from "@/mixins/order/const/orderTicketAcConstant.js";
import OrderTicketConstant from "@/mixins/order/const/orderTicketConstant.js";

export const modules = {
  store,
};

export const state = {
  _info: {
    amount: 0,
  },
  _origin: [],
  _items: [],
};

export const mutations = {
  [OrderTicketConstant.ADD_INFO_AMOUNT]: (state, payload) => {
    state._info.amount = payload;
  },
  [OrderTicketConstant.ADD_TICKET_DEAL]: (state, payload) => {
    state._origin = [];
    state._items = [];
    state._origin = payload;
    state._items = payload;
  },
  [OrderTicketConstant.SET_TICKET_ALLSTATE]: state => {
    state._items = state._origin.map(e => e);
  },
  [OrderTicketConstant.SET_TICKET_ORDERSTATE]: state => {
    state._items = state._origin
      .map(e => {
        if (e.dealType === "결제") {
          return e;
        }
      })
      .filter(q => q);
  },
  [OrderTicketConstant.SET_TICKET_USESTATE]: state => {
    state._items = state._origin
      .map(e => {
        if (e.dealType === "사용") {
          return e;
        }
      })
      .filter(q => q);
  },
  [OrderTicketConstant.SET_TICKET_CANCELSTATE]: state => {
    state._items = state._origin
      .map(e => {
        if (e.dealType === "취소") {
          return e;
        }
      })
      .filter(q => q);
  },
};

export const actions = {
  async acOrderTicketAmount({ commit }, params) {
    const url = OrderTicketAcConstant.GET_ORDER_TICKET_AMOUNT;
    try {
      const res = await api.get(`${url}?lte=${params ?? ""}`);
      if (res.data?.code === 0) {
        commit(
          OrderTicketConstant.ADD_INFO_AMOUNT,
          res.data?.code === 0 ? res.data.data.amount : 0,
        );
      }
      return res.data?.code === 0 && res.data.data?.amount > 0;
    } catch (error) {
      return false;
    }
  },
  async acOrderTicketDeal({ commit }) {
    const url = OrderTicketAcConstant.GET_ORDER_TICKET_DEAL;
    try {
      const res = await api.get(url);
      console.log("왜없냐", res.data.data);
      if (res.data?.code === 0) {
        commit(OrderTicketConstant.ADD_TICKET_DEAL, res.data?.code === 0 ? res.data.data : []);
      }
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acOrderTicketSave({ commit }, payload) {
    const url = OrderTicketAcConstant.POST_ORDER_TICKET;
    try {
      const res = await api.post(url, payload);
      if (res.data?.code !== 0) {
        return null;
      }
      const { encrypted_order_seq, merchant_uid } = res.data.data ?? {};
      if (encrypted_order_seq) {
        store.commit("setEncryptedOrderSeq", encrypted_order_seq);
      }
      return merchant_uid ?? null;
    } catch (error) {
      return null;
    }
  },
  async acOrderTicketUse({ commit }, payload) {
    const url = OrderTicketAcConstant.POST_ORDER_TICKET_USE;
    try {
      const res = await api.post(`${url}/${payload.id}`, { status: payload.status });
      return res.data?.code === 0;
    } catch (error) {
      const code = error?.response?.data?.code;
      // 1308 = 'ticket already'(이 주문에 이미 use 딜 존재). 이미 사용 목적이 달성된 정상 상태이므로
      // 성공 취급(마이페이지 폴백 방지) — 일반 유저 중복제출 방어에도 안전.
      if (code === 1308) return true;
      // 1306 = 'ticket count'(잔액 0). 다방(NZSC-3205)은 결제 시 서버가 이용권을 자동 사용하므로
      // 잔액이 이미 0 → FE 재호출이 1306(잔액0 체크가 1308 use딜 체크보다 앞서므로 1308이 아닌 1306)으로
      // 실패한다. 다방 세션에 한해 성공 취급. 일반 유저의 1306(진짜 이용권 없음)은 그대로 실패 유지.
      if (code === 1306 && window.sessionStorage.getItem("dabang_entered") === "1") return true;
      return false;
    }
  },
  async acOrderTicketPayment({ commit }, payload) {
    const url = OrderTicketAcConstant.POST_ORDER_TICKET_PAYMENT;
    try {
      const res = await api.post(url, payload);
      return res.data?.code === 0 ? res.data.data.merchant_uid : null;
    } catch (error) {
      return false;
    }
  },
  async acOrderTicketDirect({ commit }, payload) {
    const url = OrderTicketAcConstant.POST_ORDER_TICKET_DIRECT;
    try {
      const res = await api.post(url, payload);
      return res.data;
    } catch (error) {
      return null;
    }
  },
  async acOrderTicketBusiness({ commit }, payload) {
    const url = OrderTicketAcConstant.POST_ORDER_TICKET_BUSINESS;
    try {
      const res = await api.post(url, payload);
      return res.data?.code === 0;
    } catch (error) {
      return null;
    }
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
